export default "__VITE_ASSET__BwRcuLZL__"